import { useMaterialUIController } from "context";
import Dashboard from "layouts/dashboard";
import SuperUserDashboard from "layouts/dashboard/superuser";

/**
 * Super users get the platform-wide stats dashboard instead of the
 * transaction dashboard; every other role keeps the existing one.
 */
function DashboardSwitch() {
  const [controller] = useMaterialUIController();
  const { user } = controller;

  return user?.role === "SUPERADMIN" ? <SuperUserDashboard /> : <Dashboard />;
}

export default DashboardSwitch;
